
import React from 'react'

export default function JavaScript() {
    return (
        <>
            {/* <script src={`${process.env.PUBLIC_URL}/assets/vendors/js/vendor.bundle.base.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/vendors/chart.js/chart.umd.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/vendors/progressbar.js/progressbar.min.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/vendors/jvectormap/jquery-jvectormap.min.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/vendors/jvectormap/jquery-jvectormap-world-mill-en.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/vendors/owl-carousel-2/owl.carousel.min.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/jquery.cookie.js" type="text/javascript`}></script>

            <script src={`${process.env.PUBLIC_URL}/assets/js/off-canvas.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/misc.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/settings.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/todolist.js`}></script>

            <script src={`${process.env.PUBLIC_URL}/assets/js/proBanner.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/dashboard.js`}></script>
            <script src={`${process.env.PUBLIC_URL}/assets/js/select2.js`}></script> */}

        </>
    )
}